import FleetStrip from "./FleetStrip";
import ChurnRadar from "./ChurnRadar";
import AccountOpportunities from "./AccountOpportunities";
import LiveReadinessCard from "./LiveReadinessCard";
import RecentSignups from "./RecentSignups";
import SupportIssues from "./SupportIssues";
import SubscriptionHealth from "./SubscriptionHealth";
import {
  PlatformStrategicProvider,
  GrowthTrend,
  UsageTrend,
  TopPerformingClients,
  UnderusedClients,
  ClientMovementStrip,
} from "./PlatformStrategicRow";

/**
 * Platform Command Centre — 4-row layout.
 * Row 1: Fleet Strip (Hero) — MRR · Active Orgs · High Risk · Expansion Pipeline
 * Row 2: Immediate Action — Churn Radar · Account Opportunities
 * Row 3: Operations — Live Readiness · Recent Signups · Support/Issues
 * Row 4: Strategic — Growth · Usage · Top Performing · Underused + movement strip
 */
export default function PlatformCommandCentre({ onNavigateToIntegrations }) {
  return (
    <PlatformStrategicProvider>
      <div className="space-y-6" data-testid="platform-command-centre">
        {/* ROW 1 — FLEET STRIP (HERO) */}
        <FleetStrip />

        {/* ROW 2 — IMMEDIATE ACTION */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <ChurnRadar />
          <AccountOpportunities />
        </div>

        {/* ROW 3 — OPERATIONS */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <LiveReadinessCard onManage={onNavigateToIntegrations} />
          <RecentSignups />
          <SupportIssues />
        </div>

        {/* ROW 4 — STRATEGIC */}
        <ClientMovementStrip />
        <SubscriptionHealth />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <GrowthTrend />
          <UsageTrend />
          <TopPerformingClients />
          <UnderusedClients />
        </div>
      </div>
    </PlatformStrategicProvider>
  );
}
